import { useEffect, useState } from "react";
import { Carte, CorpsCarte, EnTeteCarte } from "@/composants/ui/carte";
import { Chargement, Erreur } from "@/composants/ui/etats";
import { api, ErreurApi, type Sante } from "@/lib/api";

/** Ce que `deploy.sh` et la supervision sondent, rendu lisible à l'écran. */
export function PageExploitation() {
  const [sante, setSante] = useState<Sante | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);

  useEffect(() => {
    const controleur = new AbortController();
    api
      .sante(controleur.signal)
      .then(setSante)
      .catch((cause) => {
        if (cause instanceof DOMException && cause.name === "AbortError") return;
        setErreur(cause instanceof ErreurApi ? cause.message : "Une erreur est survenue.");
      });
    return () => controleur.abort();
  }, []);

  if (erreur) return <Erreur message={erreur} />;
  if (!sante) return <Chargement />;

  const lignes: Array<[string, string]> = [
    ["Version", sante.version],
    ["Environnement", sante.environnement],
    ["Base de données", sante.base],
    ["Révision de migration", sante.revision_migration ?? "—"],
  ];

  return (
    <Carte className="max-w-lg">
      <EnTeteCarte>
        <h1 className="font-medium text-encre">État du service</h1>
      </EnTeteCarte>
      <CorpsCarte>
        <dl className="flex flex-col gap-2 text-sm">
          {lignes.map(([libelle, valeur]) => (
            <div key={libelle} className="flex justify-between gap-4">
              <dt className="text-encre-douce">{libelle}</dt>
              <dd className="font-mono text-encre">{valeur}</dd>
            </div>
          ))}
        </dl>
      </CorpsCarte>
    </Carte>
  );
}
